import { render, staticRenderFns } from "./ButtonBlock.vue?vue&type=template&id=b4aa5c1a&scoped=true"
import script from "./ButtonBlock.vue?vue&type=script&lang=js"
export * from "./ButtonBlock.vue?vue&type=script&lang=js"
import style0 from "./ButtonBlock.vue?vue&type=style&index=0&id=b4aa5c1a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4aa5c1a",
  null
  
)

export default component.exports